export const BOTTOM_VALUE_PHONE_DEFAULT = 20
export const BOTTOM_VALUE_DESKTOP_DEFAULT = 40
export const BOTTOM_ANIMATION_OFFSET = 8
export const AUTO_DISMISS_TIME_DEFAULT = 4
export const AUTO_DISMISS_TIME_MIN = 4
export const AUTO_DISMISS_TIME_MAX = 10
